module.exports = __webpack_public_path__ + "static/media/bg2.8a5ad970.webp";